import React from "react";
import {
    calculateStrengthVolumeByMuscle,
    calculateStrengthWeeklyVolumeByMuscle,
} from "../../domain/strength/calculations";

const StrengthVolumeSummary = ({ workout = {}, workouts = [] }) => {
    const sessionVol = calculateStrengthVolumeByMuscle(workout);
    const weeklyVol = calculateStrengthWeeklyVolumeByMuscle(workouts);

    const hasSessionVolume = Object.keys(sessionVol).length > 0;
    const hasWeeklyVolume = Object.keys(weeklyVol).length > 0;

    if (!hasSessionVolume && !hasWeeklyVolume) return null;

    return (
        <div className="bg-light-subtle border rounded p-3 mb-3 strength-volume-summary">
            <style>{`
                .strength-volume-summary {
                    background-color: #fafbfc !important;
                }
                .strength-volume-title {
                    font-size: 11px !important;
                    letter-spacing: 0.5px;
                    color: #495057;
                }
                .strength-volume-badge {
                    font-size: 11px !important;
                    font-weight: 600 !important;
                    padding: 5px 10px !important;
                    border: 1px solid rgba(255, 87, 34, 0.15) !important;
                    background-color: #fff !important;
                    color: #e65100 !important;
                    border-radius: 999px !important;
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                }
                .strength-weekly-badge {
                    border-color: rgba(33, 150, 243, 0.15) !important;
                    color: #0d47a1 !important;
                }
            `}</style>

            <div className="row g-3">
                {hasSessionVolume && (
                    <div className="col-12 col-md-6">
                        <div className="fw-bold text-uppercase strength-volume-title mb-2 d-flex align-items-center gap-1">
                            <i className="mdi mdi-chart-donut text-warning" style={{ color: '#FF5722' }} />
                            Volume do Treino Atual (Séries)
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {Object.entries(sessionVol).map(([muscle, count]) => (
                                <span key={`session-${muscle}`} className="strength-volume-badge shadow-sm">
                                    <span>{muscle}:</span>
                                    <strong>{count}</strong>
                                </span>
                            ))}
                        </div>
                    </div>
                )}

                {hasWeeklyVolume && workouts.length > 1 && (
                    <div className="col-12 col-md-6 border-start-md">
                        <div className="fw-bold text-uppercase strength-volume-title mb-2 d-flex align-items-center gap-1">
                            <i className="mdi mdi-calendar-multiselect text-primary" />
                            Volume Semanal Total (Séries)
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {Object.entries(weeklyVol).map(([muscle, count]) => (
                                <span key={`weekly-${muscle}`} className="strength-volume-badge strength-weekly-badge shadow-sm">
                                    <span>{muscle}:</span>
                                    <strong>{count}</strong>
                                </span>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StrengthVolumeSummary;
